import { Link } from "react-router-dom";
import FavoriteButton from "@/components/feature/FavoriteButton";

interface WorkCardProps {
  work: {
    id: string;
    title: string;
    cover: string;
    type: string;
    year: number;
    status: string;
    rating: number;
    tags: string[];
    duration?: string;
  };
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <article className="group">
      <div className="relative w-full aspect-[3/4] overflow-hidden rounded-lg bg-background-200">
        <Link to={`/works/${work.id}`} className="block w-full h-full">
          <img
            src={work.cover}
            alt={`${work.title} 海报`}
            title={`${work.title} 吴梦梦影视作品`}
            className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
          <span className="absolute inset-0 bg-gradient-to-t from-primary-950/75 via-primary-950/5 to-transparent opacity-80" />
        </Link>

        <span className="absolute top-2.5 left-2.5 flex items-center gap-1 h-6 px-2 rounded-md bg-background-50/90 backdrop-blur text-[11px] font-label font-bold text-foreground-900 pointer-events-none">
          <i className="ri-star-fill text-accent-500 text-[10px] leading-none" />
          {work.rating.toFixed(1)}
        </span>

        <div className="absolute top-2 right-2">
          <FavoriteButton
            variant="icon"
            item={{
              key: `work:${work.id}`,
              type: "work",
              id: work.id,
              title: work.title,
              cover: work.cover,
              meta: `${work.type} · ${work.year}`,
            }}
          />
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 pointer-events-none">
          <div className="flex flex-wrap items-center gap-1.5">
            {work.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 rounded text-[10px] bg-background-50/15 text-background-50 border border-background-50/25"
              >
                {tag}
              </span>
            ))}
            <span className="px-1.5 py-0.5 rounded text-[10px] bg-accent-500 text-primary-950 font-semibold">
              {work.status}
            </span>
          </div>
        </div>
      </div>

      <div className="pt-3">
        <h3 className="text-[15px] font-semibold text-foreground-950 leading-snug truncate">
          <Link to={`/works/${work.id}`} className="hover:text-primary-600 transition-colors">
            {work.title}
          </Link>
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 font-label tracking-wide">
          {work.type} · {work.year}年{work.duration ? ` · ${work.duration}` : ""}
        </p>
      </div>
    </article>
  );
}